import React, {Component} from "react";
import FlexView from "react-flexview";
import {connect} from "react-redux";
import ModalContainer from "../../../modules/commons/ModalContainer";
import SimpleButton from "../../../modules/commons/SimpleButton";
import SimpleAlert from "../../../modules/popup/SimpleAlert";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import SimpleModal from "../../../modules/popup/SimpleModal";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import SimpleInput from "../../../modules/SimpleInput";
import ErrorAction from "../../../Redux/ErrorRedux";
import Api from "../../../Services/Api";
import MasterPenjualanEditAddModal from "./masterPenjualanEditAddModal";
import {HttpStatus, Status} from "../../common/Constants";
import * as R from "ramda";
import {fetchDataAsync} from "../../../Services/Utils";
import SimpleDDL from "../../../modules/SimpleDDL";
import { mapToObjectDDL } from "../../common/mapper";
import { defaultTableChange } from "../../../modules/custom/customTable";

class MasterPenjualanEdit extends Component {
    tableColumns = [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (value, tableMeta) => {
                    return <>{tableMeta.rowIndex + 1}</>;
                },
                sort: false,
            },
        },
        {
            name: "userName",
            label: "Username",
        },
        {
            name: "salesName",
            label: "Nama User",
        },
        {
            name: "salesType",
            label: "Jenis",
            options: {
                customBodyRender: (val, {rowIndex}) => (
                    <SimpleDDL
                        id="select_options_jenisTL"
                        styles={{
                            menu: (provided) => ({
                                ...provided,
                                position: "relative",
                                fontFamily: "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
                            }),
                        }}
                        isClearable
                        value={val}
                        options={this.state.salesTypeOptions}
                        onChange={(value) => {
                            this.setState((prevValue) => ({
                                ...prevValue,
                                dataTable: prevValue.dataTable.map((d, idx) =>
                                    idx === rowIndex ? {...d, salesType: value} : d
                                ),
                            }));
                        }}
                        containerclassname="margin-bottom-none"
                        box="search"
                        name="jenisTL"
                    />
                ),
            },
        },
        {
            name: "salesId",
            label: "Aksi",
            options: {
                customBodyRender: (val, tableMeta) => {
                    return (
                        <SimpleButton
                            className="btnAct"
                            category="action_button"
                            style={{marginRight: 15, backgroundColor: "transparent"}}
                            onClick={() => this.handleConfirmDeletePopupVisibility(val, tableMeta.rowIndex)}
                            icon={
                                <i
                                    className="fa fa-trash"
                                    style={{
                                        backgroundColor: "transparent",
                                        color: "red",
                                        fontSize: 20,
                                    }}
                                />
                            }
                        />
                    )
                },
            },
        },
    ];

    constructor(props) {
        super(props);
        this.data = props.data;
        this.state = {
            deleteId: "",
            deleteIdx: null,
            loading: false,
            addVisible: false,
            dataTable: [],
            listSales: [],
            salesTypeOptions: [],
            pagination: {
                page: 1,
                limit: 5,
                totalData: 0,
            },
        };
    }

    componentDidMount = async () => {
        this.setState((prevValue) => ({...prevValue, loading: true}));
        let response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getMasterSalesById,
            menuName: "Master Sales",
            setError: this.props.setError,
            args: this.data.salesId,
        });
        if (response.ok && response.data.status === HttpStatus.SUCCESS) {
            this.setState((prevValue) => ({
              ...prevValue,
              dataTable: response.data.data?.map((item) => ({
                ...item,
                salesType: {
                  label: item.salesType.value,
                  value: item.salesType.key,
                },
              })),
            }));
        }
        await this.fetchAllSales();
        await this.fetchSalesType()
        this.setState((prevValue) => ({...prevValue, loading: false}));
    }

    fetchSalesType = async () => {
        const res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizpar,
            menuName: "Master Sales",
            setError: this.props.setError,
            args: {
                paramFilters: {
                    bizparCategory: "SALES_TYPE",
                    systemId:"SLSTYP",
                    status: Status.ACTIVE,
                },
            },
        })
        if(res.ok && res.data.status === HttpStatus.SUCCESS){
            this.setState(prev=>({
                ...prev,
                salesTypeOptions: res.data.data?.map((d) => mapToObjectDDL(d.value, d.key)),
            }))
        }
    }

    fetchAllSales = async () => {
        let response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").findSalesNotInSalesTeam,
            menuName: "Master Sales",
            setError: this.props.setError,
            args: this.props.kodeCabang,
        });
        if (response.ok && response.data.status === HttpStatus.SUCCESS) {
            this.setState((prevValue) => ({
                ...prevValue,
                listSales: response.data.data?.map((sales) => ({...sales, checked: false})),
            }));
        }
    };

    handleConfirmDeletePopupVisibility = (val, id) => {
        if (!R.isNil(id)) {
            this.setState((prevValue) => ({
                ...prevValue,
                deleteIdx: id,
                deleteId: val,
            }));
            return;
        }

        this.setState((prevValue) => ({
            ...prevValue,
            deleteId: "",
            deleteIdx: null,
        }));
    };

    handleSubmitDelete = async () => {
        this.handleTriggerLoading();
        const deletedId = this.state.deleteId;
        const deleteIdx = this.state.deleteIdx;
        let {listSales} = this.state;

        if (!R.isNil(deletedId) && !R.isEmpty(deletedId)) {
            await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").deleteSales,
                menuName: "Master Sales",
                setError: this.props.setError,
                args: deletedId,
            });
        }

        let deleted = this.state.dataTable[deleteIdx]
        listSales.push({
            ...deleted,
            salesId: null,
            checked: false,
        })

        this.setState((prevState) => ({
            ...prevState,
            dataTable: prevState.dataTable.filter((_, idx) => idx !== deleteIdx),
            listSales,
        }))
        this.handleConfirmDeletePopupVisibility();
        this.handleTriggerLoading();
    };

    handleAddVisibility = () => {
        this.setState((prevValue) => ({...prevValue, addVisible: !prevValue.addVisible}));
    };

    handleAddSales = (sales) => {
        const salesData = [];
        for (const s of sales) {
            const salesExist = this.state.dataTable.find((d) => d.employeeId === s.employeeId);
            if (!salesExist) {
                salesData.push(s);
            }
        }

        this.setState((prevValue) => ({
            ...prevValue,
            dataTable: [...prevValue.dataTable, ...salesData],
            listSales: prevValue.listSales.filter(item => !item.checked),
        }));
        this.handleAddVisibility();
    };

    handleSave = async () => {
        this.handleTriggerLoading();
        const request = {
            salesLeadId: this.data.salesId,
            salesTeam: this.state.dataTable.map((d) => ({
                employeeId: d.employeeId,
                kodeCabang: this.props.kodeCabang,
                salesLeadId: this.data.salesId,
                salesType: d.salesType?.value,
            })),
        };

        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").createMasterSales,
            menuName: "Master Sales",
            setError: this.props.setError,
            args: request,
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            await this.props.onFetch({}, 1, 5);
            this.props.onClickClose();
        }


        this.handleTriggerLoading();
    };

    handleTriggerLoading = () => {
        this.props.triggerLoading();
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
        this.props.triggerLoading();
    };

    handleChecked = (index) => {
        this.setState((prevValue) => ({
            ...prevValue,
            listSales: prevValue.listSales.map((item, idx) => {
                if (idx === index) {
                    return {...item, checked: !item.checked};
                } else return item;
            })
        }));
    }

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: tableState.page + 1,
            }
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: 1,
                limit: tableState.rowsPerPage,
            }
        }));
    };

    render() {
        const {pagination} = this.state;
        return (
            <>
                <SimpleModal
                    title="Data Sales"
                    visible={!!this.data}
                    onClickClose={this.props.onClickClose}
                    content={
                        <ModalContainer>
                            <div
                                className="grid grid-2x grid-mobile-none gap-15px"
                                style={{alignItems: "center"}}
                            >
                                <div id="grid-1">
                                    <SimpleInput
                                        id="input_text_usernameTL"
                                        value={this.data.userName}
                                        readOnly
                                        label="Username TL"
                                    />
                                    <SimpleInput
                                        id="input_text_namaTL"
                                        value={this.data.salesLeadName}
                                        readOnly
                                        label="Nama Team Lead"
                                    />
                                </div>
                                <div id="grid-2">
                                    <SimpleInput
                                        id="input_text_cabang"
                                        value={this.data.cabang}
                                        readOnly
                                        label="Cabang"
                                    />
                                    <SimpleInput
                                        id="input_text_tl"
                                        value={this.data.salesType}
                                        readOnly
                                        label="Team Lead"
                                    />
                                </div>
                            </div>
                            <SimpleDataTable
                                key={`${pagination.page}-${pagination.limit}-${this.state.dataTable.length}`}
                                data={this.state.dataTable}
                                columns={this.tableColumns}
                                toCount={this.state.dataTable.length}
                                rowsPerPage={pagination.limit}
                                page={pagination.page - 1}
                                options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
                            />
                            <FlexView hAlignContent="right" className="margin-top-15px">
                                <SimpleButton
                                    icon={<i className="fa fa-plus margin-right-10px"></i>}
                                    onClick={this.handleAddVisibility}
                                >
                                    Tambah
                                </SimpleButton>
                                <SimpleButton onClick={this.handleSave}>Simpan</SimpleButton>
                            </FlexView>
                        </ModalContainer>
                    }
                />
                {!R.isNil(this.state.deleteIdx) && (
                    <SimpleAlert
                        title="Information"
                        visible={!R.isNil(this.state.deleteIdx)}
                        onClickClose={() => this.handleConfirmDeletePopupVisibility()}
                        content={
                            <>
                                <p>Apakah anda yakin menghapus Data Sales?</p>
                                <FlexView hAlignContent="center" className="margin-top-15px">
                                    <SimpleButton secondary onClick={() => this.handleConfirmDeletePopupVisibility()}>
                                        Batal
                                    </SimpleButton>
                                    <SimpleButton onClick={this.handleSubmitDelete}>Iya</SimpleButton>
                                </FlexView>
                            </>
                        }
                    />
                )}
                {this.state.addVisible && (
                    <MasterPenjualanEditAddModal
                        listSales={this.state.listSales}
                        handleChecked={this.handleChecked}
                        kodeCabang={this.props.kodeCabang}
                        visible={this.state.addVisible}
                        onAddSales={this.handleAddSales}
                        onClickClose={this.handleAddVisibility}
                    />
                )}
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(MasterPenjualanEdit);